(function () {
  var section = document.getElementById('float_right');
  if (!section) return;

  var btnHide = section.querySelector('.MS__sprite-btn-hide');
  var btnShow = section.querySelector('.MS__sprite-btn-show');

  btnHide.addEventListener('click', function (e) {
    e.preventDefault();
    section.classList.add('is-collapsed');
  });

  btnShow.addEventListener('click', function (e) {
    e.preventDefault();
    section.classList.remove('is-collapsed');
  });
})();
